import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getEquipmentRegistrations(companyId, equipmentId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,dtConfig[ModulesMap.EQUIPMENT_REGISTRATIONS].getEquipmentRegistrations, {
		urlParams: {
			companyId,
			equipmentId,
		},
	})
}
function getEquipmentRegistration(companyId, equipmentId, registrationId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,dtConfig[ModulesMap.EQUIPMENT_REGISTRATIONS].getEquipmentRegistration, {
		urlParams: {
			companyId,
			equipmentId,
            registrationId,
		},
	})
}

function createEquipmentRegistration(companyId, equipmentId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,dtConfig[ModulesMap.EQUIPMENT_REGISTRATIONS].createEquipmentRegistration, {
		urlParams: {
			companyId,
            equipmentId,
		},
		...data,
	})
}

function patchEquipmentRegistration(companyId, equipmentId, registrationId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,dtConfig[ModulesMap.EQUIPMENT_REGISTRATIONS].patchEquipmentRegistration, {
		urlParams: {
			companyId,
			equipmentId,
            registrationId,
		},
		...data,
	})
}

function putEquipmentRegistration(companyId, equipmentId, registrationId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,dtConfig[ModulesMap.EQUIPMENT_REGISTRATIONS].putEquipmentRegistration, {
		urlParams: {
			companyId,
			equipmentId,
            registrationId,
		},
		...data,
	})
}

function deleteEquipmentRegistration(companyId, equipmentId, registrationId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT_REGISTRATIONS,dtConfig[ModulesMap.EQUIPMENT_REGISTRATIONS].deleteEquipmentRegistration, {
		urlParams: {
			companyId,
			equipmentId,
            registrationId,
		},
	})
}

export default {
    getEquipmentRegistrations,
    getEquipmentRegistration,
    createEquipmentRegistration,
    patchEquipmentRegistration,
    putEquipmentRegistration,
    deleteEquipmentRegistration,
}
